import Int64LookupListResultModelBase from '../_generated/modelBases/int64-lookup-list-result-model-base';

export default class Int64LookupListResultModel extends Int64LookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
